<template>
  <div id="app">
    <nav>
      <ul>
        <li><router-link to="/">Login</router-link></li>
        <li><router-link to="/upload">Upload</router-link></li>
        <li><router-link to="/results">Results</router-link></li>
        <li><router-link to="/download">Download</router-link></li>
      </ul>
    </nav>
    <router-view/>
    <LogoutButton/>
  </div>
</template>

<script>
import LogoutButton from './components/LogoutButton.vue';

export default {
  name: 'App',
  components: {
    LogoutButton
  }
}
</script>
